import type { SVGProps } from "react";
export interface Watch03IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Watch03Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Watch03IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.916 18.053a1.124 1.124 0 1 1 2.17.595l-.355 1.295c-.179.652-.33 1.263-.642 1.762l-.143.207a3.1 3.1 0 0 1-1.095.893l-.186.084c-.466.192-.983.23-1.538.236h-2.253c-.463-.006-.9-.031-1.302-.151l-.237-.085a3.1 3.1 0 0 1-1.15-.82l-.13-.157c-.31-.4-.482-.889-.635-1.423l-.15-.546-.355-1.295-.025-.113a1.126 1.126 0 0 1 2.16-.592l.036.11.354 1.295.16.57c.13.444.18.546.234.617l.075.086a.9.9 0 0 0 .284.188l.104.029c.138.025.413.037 1.144.037h1.118c.976 0 1.14-.021 1.25-.066l.102-.05a.9.9 0 0 0 .256-.224l.056-.093c.06-.126.143-.388.337-1.094zM10.876 8.5a1.125 1.125 0 0 1 2.25 0v3.035l1.67 1.67.077.085a1.126 1.126 0 0 1-1.583 1.583l-.085-.078-2-2c-.21-.21-.33-.496-.33-.794V8.5ZM20.5 9.875c.621 0 1.125.504 1.125 1.125v2c0 .62-.504 1.124-1.125 1.124h-1.07A1.121 1.121 0 0 1 18.923 12a1.12 1.12 0 0 1-.618-.999c0-.621.504-1.125 1.125-1.125zm-7.941-9c.772 0 1.484-.02 2.106.236l.186.083c.428.21.802.516 1.095.894l.143.206c.311.5.463 1.11.642 1.763l.354 1.296a1.124 1.124 0 0 1-2.17.595L14.56 4.65c-.194-.706-.277-.967-.337-1.094l-.056-.092a.9.9 0 0 0-.256-.224l-.103-.05c-.11-.045-.273-.066-1.25-.066h-1.117c-.974 0-1.138.02-1.248.066a.9.9 0 0 0-.359.274c-.073.094-.136.245-.394 1.186l-.354 1.297a1.125 1.125 0 0 1-2.171-.595l.356-1.296c.204-.745.372-1.437.783-1.97l.13-.156a3.1 3.1 0 0 1 1.15-.82l.238-.084c.564-.168 1.193-.152 1.87-.152z"
      />
      <path
        fill={color}
        d="M18.375 12a6.375 6.375 0 1 0-12.75 0 6.375 6.375 0 0 0 12.75 0m2.25 0a8.625 8.625 0 1 1-17.25 0 8.625 8.625 0 0 1 17.25 0"
      />
    </svg>
  );
}
